import Diversity1Icon from '@mui/icons-material/Diversity1';
import { withClarityTheme } from '@verifime/styles';
import { EntityTypeTile } from '../EntityTypeTile';

export type RegulatedTrustTileProps = {
  /**
   * Whether this tile is currently selected
   */
  selected?: boolean;
  /**
   * Callback when the tile is clicked
   */
  onClick?: () => void;
  /**
   * Optional data-testid for testing
   */
  dataTestId?: string;
};

/**
 * RegulatedTrustTile is a pre-configured EntityTypeTile for the Regulated Trust entity type.
 *
 * @example
 * ```tsx
 * <RegulatedTrustTile
 *   selected={selectedType === 'regulated-trust'}
 *   onClick={() => setSelectedType('regulated-trust')}
 * />
 * ```
 */
const RegulatedTrustTileComponent = ({
  selected,
  onClick,
  dataTestId,
}: Readonly<RegulatedTrustTileProps>) => {
  return (
    <EntityTypeTile
      icon={<Diversity1Icon />}
      // The title is copied in person-api (Greengate-Fintech/person-api), the label mapping in
      // src/main/java/com/greengate/verifime/service/notification/InviteEmailEntityData.java,
      // and sent by CustomerInvitedNotificationHandler (event/vertx). Change both together.
      title="Regulated Trust"
      description="A trust overseen by regulators like ASIC or APRA, usually for managed investments."
      hint="Choose this if you manage a registered investment trust or managed investment scheme."
      selected={selected}
      onClick={onClick}
      dataTestId={dataTestId}
    />
  );
};

export const RegulatedTrustTile = withClarityTheme(RegulatedTrustTileComponent);
